import Add from '@/pages/add/view'
import Create from '@/pages/create/view'
import Search from '@/pages/search/view'

const menu=[
    {
        path: '/add',
        name: 'add',
        meta: {
            icon: 'el-icon-plus',
            name:'新增停车券',
            title:'道闸商户平台'
        },
        component: Add
    },
    {
        path: '/create',
        name: 'create',
        meta: {
            icon: 'el-icon-plus',
            name:'生成停车券',
            title:'道闸商户平台'
        },
        component: Create
    },
    {
        path: '/search',
        name: 'search',
        meta: {
            icon: 'el-icon-search',
            name:'停车券购买查询',
            title:'道闸商户平台'
        },
        component: Search
    },
]

export default menu


// WEBPACK FOOTER //
// ./src/router/menu.js